/** @type {import('next').NextConfig} */

// eslint-disable-next-line
const { createPresentonProxyConfig, resolvePresentonCapabilityState } = require('./src/config/presenton-proxy')

const presentonProxyConfig = createPresentonProxyConfig()
const presentonCapabilityState = resolvePresentonCapabilityState()

const nextConfig = {
  env: {
    NEXT_PUBLIC_PRESENTON_CAPABILITY_STATE: presentonCapabilityState ? 'true' : 'false',
  },
  eslint: {
    dirs: ['src'],
  },

  reactStrictMode: true,
  swcMinify: true,

  productionBrowserSourceMaps: true,

  // Remote patterns for image optimization
  images: {
    remotePatterns: [
      {
        protocol: 'https',
        hostname: 'example.com',
      },
      {
        protocol: 'https',
        hostname: 'fsds-content-develop.s3.ap-southeast-1.amazonaws.com',
      },
      {
        protocol: 'https',
        hostname: 'fsds-content-prod.s3.ap-southeast-1.amazonaws.com',
      },
      {
        protocol: 'https',
        hostname: 'fsds-resource-prod.s3.ap-southeast-1.amazonaws.com',
      },
      {
        protocol: 'https',
        hostname: 'fsds-resource-develop.s3.ap-southeast-1.amazonaws.com',
      },
      // Tenant-scoped S3 buckets (e.g. edunodes-phongth-resource.s3.ap-southeast-1.amazonaws.com)
      {
        protocol: 'https',
        hostname: '*.s3.ap-southeast-1.amazonaws.com',
        pathname: '/**',
      },
      {
        protocol: 'https',
        hostname: 'fsds-content.s3.ap-southeast-1.amazonaws.com',
      },
      {
        protocol: 'https',
        hostname: 'fsds-content-dev.s3.ap-southeast-1.amazonaws.com',
      },
      {
        protocol: 'https',
        hostname: 'github.com',
      },
      {
        protocol: 'https',
        hostname: 'fullstackdatascience.com',
      },
      {
        protocol: 'https',
        hostname: 'media.giphy.com',
      },
      {
        protocol: 'https',
        hostname: 'images.unsplash.com',
      },
    ],
  },

  i18n: {
    locales: ['vi', 'en'],
    defaultLocale: 'vi',
    localeDetection: false,
  },

  ...(presentonProxyConfig
    ? {
        experimental: {
          // Presentation exports can legitimately exceed Next's 30-second proxy default.
          proxyTimeout: 300_000,
        },
        async rewrites() {
          return {
            beforeFiles: presentonProxyConfig.rewrites,
            afterFiles: [],
            fallback: [],
          }
        },
      }
    : {}),

  webpack(config) {
    // Grab the existing rule that handles SVG imports
    const fileLoaderRule = config.module.rules.find(rule => rule.test?.test?.('.svg'))

    config.module.rules.push(
      // Reapply the existing rule, but only for svg imports ending in ?url
      {
        ...fileLoaderRule,
        test: /\.svg$/i,
        resourceQuery: /url/, // *.svg?url
      },
      // Convert all other *.svg imports to React components
      {
        test: /\.svg$/i,
        issuer: { not: /\.(css|scss|sass)$/ },
        resourceQuery: { not: /url/ }, // exclude if *.svg?url
        loader: '@svgr/webpack',
        options: {
          dimensions: false,
          titleProp: true,
        },
      }
    )

    // Modify the file loader rule to ignore *.svg, since we have it handled now.
    fileLoaderRule.exclude = /\.svg$/i

    return config
  },
}

module.exports = nextConfig
